/**
 * Contributions copy: the feed and the names of the task events it and the
 * task history render.
 */

export interface ContributionsCopy {
  readonly contributions: {
    readonly title: string;
    readonly all: string;
    readonly mine: string;
    readonly empty: string;
    readonly columns: {
      readonly when: string;
      readonly contributor: string;
      readonly task: string;
      readonly event: string;
      readonly note: string;
    };
  };

  readonly events: Readonly<Record<string, string>>;
}

export const CONTRIBUTIONS_COPY_EN: ContributionsCopy = {
  contributions: {
    title: 'Contributions',
    all: 'Everyone',
    mine: 'Mine',
    empty: 'No contributions recorded yet.',
    columns: {
      when: 'When',
      contributor: 'Contributor',
      task: 'Task',
      event: 'Event',
      note: 'Note',
    },
  },

  events: {
    proposed: 'Proposed to Backlog',
    approved: 'Approved into Ready',
    rejected: 'Rejected',
    claimed: 'Claimed into In progress',
    submitted: 'Submitted for review',
    returned: 'Returned to In progress',
    completed: 'Approved to Done',
    // Never "Approved to Done": the history must say which one happened.
    completed_directly: 'Completed by the owner, their own work',
    edited: 'Edited by the owner',
    reference_added: 'Reference added',
    dependencies_changed: 'Dependencies changed',
    deleted: 'Deleted',
  },
};

export const CONTRIBUTIONS_COPY_AR: ContributionsCopy = {
  contributions: {
    title: 'المساهمات',
    all: 'الجميع',
    mine: 'مساهماتي',
    empty: 'لا توجد مساهمات مسجلة بعد.',
    columns: {
      when: 'الوقت',
      contributor: 'المساهم',
      task: 'المهمة',
      event: 'الحدث',
      note: 'ملاحظة',
    },
  },

  events: {
    proposed: 'اقتُرحت إلى المقترحات',
    approved: 'اعتُمدت إلى جاهزة',
    rejected: 'رُفضت',
    claimed: 'استُلمت إلى قيد التنفيذ',
    submitted: 'أُرسلت للمراجعة',
    returned: 'أُعيدت إلى قيد التنفيذ',
    completed: 'اعتُمدت كمنجزة',
    completed_directly: 'أنجزها المالك، وهي من عمله',
    edited: 'عدّلها المالك',
    reference_added: 'أُضيف مرجع',
    dependencies_changed: 'تغيّرت المتطلبات السابقة',
    deleted: 'حُذفت',
  },
};
